"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_1 = require("lucide");
const ui_1 = require("@/ui/ui");
const toastProvider_1 = require("./toastProvider");
require("./toast.less");
const defaultOptions = {
    title: "",
    text: "",
    variant: "secondary"
};
class Toast extends ui_1.Component {
    constructor(target, _options) {
        super(((0, jsx_runtime_1.jsxs)("div", { className: "toast", children: [(0, jsx_runtime_1.jsx)("div", { className: "toast-close", children: (0, jsx_runtime_1.jsx)("button", { onClick: () => toastProvider_1.toastProvider.closeToast(), children: (0, lucide_1.createElement)(lucide_1.X) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "toast-main", children: [_options.title && (0, jsx_runtime_1.jsx)("span", { className: "toast-title", children: _options.title }), (0, jsx_runtime_1.jsx)("span", { className: "toast-text", children: _options.text })] })] })), target, defaultOptions, _options);
        this._element.classList.add(`toast-${this._options.variant}`);
        if (this._options.variant)
            this.variant = this._options.variant;
        if (this._options.id)
            this._element.id = this._options.id;
        // Appearing animation
        setTimeout(() => {
            this._element.style.transform = "translateY(0)";
        }, 50);
    }
    get text() {
        return this._options.text;
    }
    get title() {
        return this._options.title;
    }
    get id() {
        return this._options.id;
    }
    dispose() {
        this._element.style.transform = "";
        setTimeout(() => {
            super.dispose();
        }, 50);
    }
}
exports.Toast = Toast;
